import axios from 'axios'
import { API_URL } from '../services/SarafanApiClient/index'

const apiClient = axios.create({
  baseURL: API_URL,
  responseType: 'json',
  headers: {
    'Sarafan-Admin-Access-Token': localStorage.getItem('SARAFAN_ADMIN_ACCESS_TOKEN'),
  },
  timeout: 180000,
})

export default apiClient



// WEBPACK FOOTER //
// ./src/lib/api-client.js